var React = require('react');

function FacebookWhiteIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#facebook-app-logo_1__clip0)","key":0},React.createElement("path",{"d":"M24.563.001H1.435C.643.001 0 .643 0 1.436v23.129C0 25.358.643 26 1.435 26h12.452V15.932h-3.388v-3.924h3.388V9.114c0-3.358 2.05-5.187 5.046-5.187 1.436 0 2.668.107 3.027.154v3.51h-2.078c-1.63 0-1.944.775-1.944 1.91v2.505h3.887l-.508 3.924h-3.379V26h6.625c.793 0 1.436-.644 1.436-1.435V1.435c0-.792-.643-1.434-1.436-1.434z","fill":"#FAFAFA"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"facebook-app-logo_1__clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h26v26H0z"})))]);
}

FacebookWhiteIcon.defaultProps = {"width":"26","height":"26","fill":"none"};

module.exports = FacebookWhiteIcon;

FacebookWhiteIcon.default = FacebookWhiteIcon;
